import React from 'react';
import Layout from "../components/Layout"
import BreadCrumbs from '../components/RecipesInner/BreadCrumbs';
import Hero from '../components/RecipesInner/Hero';
// import Ingredients from '../components/RecipesInner/Ingredients';
// import CookingInstructions from '../components/RecipesInner/CookingInstructions';
import RecipesFAQ from "../components/RecipesOuter/RecipesFAQ";
import { map, mapValues } from 'lodash';
import SEO from "../components/SEO/Seo"
import RecipeContent from '../components/RecipesInner/RecipeContent';
import LazyRenderOnView from "../components/primitives/LazyRenderOnView";

const YouMayAlsoLike = React.lazy(() =>
  import("../components/RecipesInner/YouMayAlsoLike")
)
const RecipeTags = React.lazy(() => import("../components/RecipesInner/RecipeTags"))

export const Head = ({ pageContext }) => {
  const { seo, title } = pageContext?.recipe

  return (
    <SEO
      title={seo?.metaTitle ?? title}
      description={seo?.metaDescription}
      keywords={seo?.keywords}
    />
  )
}

const Recipe = ({ pageContext }) => {

  const { recipe } = mapValues(pageContext, (node) => ({
    'cookingInstructions': node?.recipesInfo?.cookingInstructions || [],
    'cookingTime': node?.recipesInfo?.cookingTime || '',
    'difficulty': node?.recipesInfo?.difficulty || '',
    'featuredImage': node?.featuredImage?.node?.gatsbyImage || '',
    'desktopBanner': node?.recipesInfo?.recipeImagery?.desktopBannerImage?.node?.gatsbyImage || node?.featuredImage?.node?.gatsbyImage || '',
    'tabletBanner': node?.recipesInfo?.recipeImagery?.tabletBannerImage?.node?.gatsbyImage || node?.featuredImage?.node?.gatsbyImage || '',
    'mobileBanner': node?.recipesInfo?.recipeImagery?.mobileBannerImage?.node?.gatsbyImage || node?.featuredImage?.node?.gatsbyImage || '',
    'ingredients': node?.recipesInfo?.ingredients || '',
    'recipeImages': map(node?.recipesInfo?.recipeImages?.nodes, (node) => node.gatsbyImage) || [],
    'recipeVideo': node?.recipesInfo?.recipeVideo?.node || null,
    'categories': map(node?.recipesInfo?.categories?.nodes, (node) => ({
      'id': node?.id || '',
      'title': node?.title || ''
    })),
    'faqs': node?.recipesInfo?.faqs || [],
    'relatedRecipes': map(node?.recipesInfo?.relatedRecipes?.nodes, (node) => ({
      'id': node?.id || '',
      'imageAlt': node?.featuredImage.node?.altText ? node?.featuredImage.node?.altText : node?.title,
      'image': node?.featuredImage?.node?.gatsbyImage || '',
      'desktopThumb': node?.recipesInfo?.recipeImagery?.desktoptabletThumbnailImage?.node?.gatsbyImage || node?.featuredImage?.node?.gatsbyImage || '',
      'mobileThumb': node?.recipesInfo?.recipeImagery?.mobileThumbnailImage?.node?.gatsbyImage || node?.featuredImage?.node?.gatsbyImage || '',
      'slug': node?.slug || '',
      'title': node?.title || '',
    })) || [],
    'recipeDetails': node?.recipesInfo?.recipeDetails || '',
    'serves': node?.recipesInfo?.serves || '',
    // 'author': node?.author?.node?.name|| '',
    'author': 'Dorot Gardens',
    'id': node?.id || '',
    'slug': node?.slug || '',
    'title': node?.title || ''
  }));

  const faqProperties = {
    background: "bg-dorot-purple rounded-lg",
    title: "text-white 1024:font-bold font-semibold",
    content: "text-white",
    padding: "px-4 py-6",
  }

  const faqIconProperties = {
    css: "text-white text-_2432 font-bold",
    icon: "+",
  }

  const faqIconOpenProperties = {
    css: "text-white text-_2432 font-bold",
    icon: "-",
  }

  const faqData = {
    faqsTitle: "FAQs about This Recipe",
    faq: recipe?.faqs,
  }

  // console.log('recipe', recipe)
  // console.log(pageContext)
  return (
    <Layout>
      <div className='px-7.5 1024:px-0'>
        <BreadCrumbs title={recipe.title}></BreadCrumbs>
      </div>
      <Hero recipe={recipe}></Hero>
      <section className='limit-1440 1024:px-12.5 lg:px-18'>
        {/* <div className='1024:flex lg:flex'>
                <div className='1024:w-[408px] lg:w-1/3 bg-dorot-ingredients-bg'>
                  <Ingredients ingredients={recipe.ingredients}></Ingredients>
                </div>
                <div className='1024:w-[616px] lg:w-2/3 bg-white'>
                    <CookingInstructions instructions={recipe.cookingInstructions}></CookingInstructions>
                    {/* <YouMayAlsoLike recipes={recipe.relatedRecipes}></YouMayAlsoLike>
                    <RecipeTags tags={recipe.categories}></RecipeTags> 
                </div>
          </div> */}

        <RecipeContent recipe={recipe} />

        {recipe.faqs?.length > 0 && (
          <RecipesFAQ
            product={faqData}
            properties={faqProperties}
            openProperties={faqProperties}
            iconProperties={faqIconProperties}
            iconOpenProperties={faqIconOpenProperties}
            hidePatterns={true}
          />
        )}

        <div className='limit-1440 mt-20'>
          <LazyRenderOnView>
            <React.Suspense fallback={null}>
              <YouMayAlsoLike recipes={recipe.relatedRecipes}></YouMayAlsoLike>
              <RecipeTags tags={recipe.categories}></RecipeTags>
            </React.Suspense>
          </LazyRenderOnView>
        </div>
      </section>
    </Layout>
  )
}

export default Recipe;
